/**
 * en-GB messages added by Phase 4 task S49 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s49EnGB = {
    'wallet.pass.host': 'Host',
    'wallet.pass.address': 'Address',
    'wallet.pass.group': 'Group',
    'wallet.pass.visitorTitle': 'Visitor pass',
    'wallet.pass.memberTitle': 'Access pass',
    'wallet.privacy.passes': 'Wallet passes',
    'wallet.error.sync_failed': 'Google could not be updated. We will try again.',
    'wallet.error.rejected': 'Google refused the update.',
    'wallet.error.not_configured': 'Google Wallet is not set up yet.',
    'wallet.error.bad_key': 'That is not a valid private key.',
    'wallet.platform.keyKept': 'The saved key is kept unless you enter a new one.',
};
//# sourceMappingURL=s49.js.map